<template>
<div class="service">
    <div id="public-head">
        <img :src="bg" alt srcset />
        <div class="title-box">
            <p class="title">服务能力</p>
            <p class="en-title">SERVICE QUALITY</p>
        </div>
        <div class="list" v-show="fw.length>0">
            <div v-for="(item,index) in fw" :class="{active:index==opt}" @click="check(index)">{{item.name}}</div>
        </div>
    </div>
    <div class="wrap">
        <p class="child-title">{{detail.name}}</p>
        <p class="child-sub-title">{{detail.ex_title}}</p>
        <div class="rich" v-html="detail.content"></div>
    </div>
</div>
</template>

<script>
import {
    fw,
    fw_view
} from "../assets/js/api";
export default {
    data() {
        return {
            opt: 0,
            fw: [],
            detail: {},
            bg: require("../assets/img/service-head.png"),
        };
    },
    watch: {
        "$route.query.idx": {
            handler(e) {
                this.opt = e || 0;
                this.getDeta();
            },
        },
    },
    created() {
        this.opt = this.$route.query.idx || 0
        fw().then((r) => {
            this.fw = r.data.data;
            if (this.$route.query.id) {
                this.fw.forEach((val, index) => {
                    if (val.id == this.$route.query.id) {
                        this.opt = index
                    }
                })
            }
            this.getDeta();
        });
    },
    methods: {
        getDeta() {
            fw_view({
                id: this.fw[this.opt].id,
            }).then((r) => {
                this.detail = r.data;
            });
        },
        check(e) {
            this.$router.push({
                path: "/service",
                query: {
                    idx: e,
                },
            });
        },
    },
};
</script>

<style lang="less" scoped>
#public-head {
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;

    &>img {
        width: 100%;
        height: 3.7rem;
    }

    .title-box {
        position: absolute;
        top: 1.41rem;
        left: 0;
        width: 100%;

        .title {
            font-size: 0.36rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            margin-bottom: 0.24rem;
            text-align: center;
        }

        .en-title {
            font-size: 0.3rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
        }
    }

    .list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        position: relative;
        top: -0.5rem;
        background: #ffffff;
        box-shadow: 0px 0px 0.25rem 0px rgba(18, 111, 204, 0.2);
        overflow: hidden;
        width: 100%;

        div {
            line-height: 1.1rem;
            width: 20%;
            text-align: center;
            font-size: 0.22rem;
            font-weight: 400;
            font-family: Source Han Sans CN;
            transition: all 0.15s linear;
        }

        div.active {
            font-weight: bold;
            color: #ffffff;
            background: #126fcc;
        }
    }
}

.wrap {
    padding: 0 .2rem;
    box-sizing: border-box;
}
</style>
